import { HawkSearchComponents, ImageContent, ImageContentComponentConfig, ImageContentComponentModel } from '@models';
import { trackingService } from '@services';
import { BaseContentComponent } from '../base-content.component';
import defaultHtml from './image-content.component.hbs';

export class ImageContentComponent extends BaseContentComponent<ImageContentComponentConfig, ImageContent, ImageContentComponentModel> {
    protected override componentName: keyof HawkSearchComponents = 'image-content';
    protected override defaultHtml = defaultHtml;

    protected override renderContent(): boolean {
        return !!this.data;
    }

    protected override getContentModel(): ImageContentComponentModel {
        return {
            ...this.data!
        };
    }

    protected override onRender(): void {
        super.onRender();

        trackingService.trackBannerImpression(this.data!.id, this.data!.campaignId);
    }

    protected bindChildElements(): void {
        this.rootElement.querySelectorAll('[hawksearch-link]').forEach((e) => {
            e.addEventListener('click', (event: Event) => {
                trackingService.trackBannerClick(this.data!.id, this.data!.campaignId);
            });
        });
    }
}
